import _ from 'lodash';
import { getAllAccounts } from '../myAccount/multiLoanDashboard/accountsSelector';
import { RootState } from '@iwProvider/configureStore';

export const CBILS_PRODUCT_TYPE = 'cbils';

const APPROVED_STATUS = 'offered';
export const INELIGIBLE_STATUS = 'ineligible';

export const getDashboardStatus = (state: RootState) => {
    const firstCBILSLoan = getFirstCBILSAccount(state);
    const loanStatus = _.get(firstCBILSLoan, 'loan_status');

    if (_.includes(['ongoing', 'topup', 'overdue', 'duetoday'], loanStatus)) {
        return APPROVED_STATUS;
    }

    return INELIGIBLE_STATUS;
};

function getAllCBILSAccounts(state: RootState) {
    return _.filter(getAllAccounts(state), {
        product_type: CBILS_PRODUCT_TYPE
    });
}

function getFirstCBILSAccount(state: RootState): any {
    const cbilsAccounts = getAllCBILSAccounts(state);

    if (hasActiveSecondCBILSLoan(state)) return _.get(cbilsAccounts, '[1]');

    return _.get(cbilsAccounts, '[0]');
}

export function getSecondCBILSAccount(state: RootState): any {
    const cbilsAccounts = getAllCBILSAccounts(state);

    if (hasActiveSecondCBILSLoan(state)) return _.get(cbilsAccounts, '[1]');
}

export function getSecondCBILSAccountOutstandingTotal(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'balance.total');
}

export function getSecondCBILSAccountId(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'account_id');
}

export function getSecondCBILSAccountOutstandingPrincipal(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'balance.principal');
}

export function getCBILSScheduledPayments(state: RootState): any {
    return _.get(getFirstCBILSAccount(state), 'scheduled_payments');
}

export function getSecondCBILSScheduledPayments(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'scheduled_payments');
}

function getBalance(state: RootState) {
    const nonCBILSaccount = getFirstCBILSAccount(state);
    return _.get(nonCBILSaccount, 'balance');
}

export function getOutstandingTotal(state: RootState): number {
    return _.get(getBalance(state), 'total');
}

function hasActiveSecondCBILSLoan(state: RootState) {
    return getAllCBILSAccounts(state).length === 2;
}
